import client from "./client";

// عميل API للإجازة الزمنية (بند 10 من مواصفات الإجازات الزمنية).
export const balance = async () => (await client.get("/time-off/balance")).data;
export const listMine = async () => (await client.get("/time-off")).data;
export const listRequests = async (status = "pending") =>
  (await client.get("/time-off/requests", { params: { status } })).data;
export const create = async (payload) => (await client.post("/time-off", payload)).data;

export const action = async (id, status, note) =>
  (await client.post(`/time-off/${id}/action`, { status, note })).data;

export const recordReturn = async (id) =>
  (await client.post(`/time-off/${id}/record-return`)).data;

export const requestCancel = async (id) =>
  (await client.post(`/time-off/${id}/request-cancel`)).data;

export const submitCancelRequest = async (id) =>
  (await client.post(`/time-off/${id}/submit-cancel-request`)).data;

export const approveCancel = async (id, approve, note) =>
  (await client.post(`/time-off/${id}/approve-cancel`, { approve, note })).data;
